// French. Keys are the English source strings; {name} marks a value filled in afterwards.
export const FR = {
  // the start screens
  'Welcome to Bamenda': 'Bienvenue à Bamenda',
  'The real Bamenda, Buea and Limbe, alive with half a million people. Before you walk in, one question.': 'Le vrai Bamenda, Buea et Limbe, avec un demi-million d\'habitants. Avant d\'entrer, une question.',
  'Your year of birth': 'Votre année de naissance',
  'For example 1998': 'Par exemple 1998',
  'Abakwa is for adults. Asked once; only whether you are eighteen is kept, never the year.': 'Abakwa est réservé aux adultes. Demandé une seule fois ; on ne garde que si vous avez dix-huit ans, jamais l\'année.',
  'The town opens at eighteen. Come back then.': 'La ville ouvre à dix-huit ans. Revenez alors.',
  Continue: 'Continuer',
  'The rules of the town': 'Les règles de la ville',
  'Who are you in this town?': 'Qui êtes-vous dans cette ville ?',
  'A name people will call across the street, and the look you walk in with.': 'Un nom qu\'on criera depuis l\'autre côté de la rue, et l\'allure avec laquelle vous entrez.',
  'Your name': 'Votre nom',
  'For example Che, Bih or Ngwa': 'Par exemple Che, Bih ou Ngwa',
  'Type a name first, so people know what to call you.': 'Écrivez d\'abord un nom, pour qu\'on sache comment vous appeler.',
  Skin: 'Peau',
  Shirt: 'Chemise',
  Trousers: 'Pantalon',
  'Where you start': 'Où vous commencez',
  'At my house': 'Chez moi',
  'You wake up at your own door in your quarter.': 'Vous vous réveillez devant votre porte, dans votre quartier.',
  'Where I really am': 'Là où je suis vraiment',
  'Asks the browser for your location; works inside the North West or South West maps.': 'Demande votre position au navigateur ; fonctionne dans les cartes du Nord-Ouest et du Sud-Ouest.',
  'Enter the town': 'Entrer dans la ville',
  'By entering you keep to ': 'En entrant, vous respectez ',
  ': adults only, no contacts or slurs in the chat.': ' : adultes seulement, ni contacts ni insultes dans le chat.',
  Language: 'Langue',
  Age: 'Âge',
  You: 'Vous',
  Childhood: 'Enfance',
  Arrival: 'Arrivée',
  Back: 'Retour',
  'So you arrive in town': 'Et vous arrivez en ville',
  'A bushfaller family sends money home every Saturday.': 'Une famille de la diaspora envoie de l\'argent chaque samedi.',
  'A quarter pikin with two legs and a seat in the njangi.': 'Un enfant du quartier, deux jambes et une place dans la tontine.',
  'Live it again': 'Revivre',
  Traits: 'Traits',
  Skills: 'Compétences',
  Dream: 'Rêve',
  Home: 'Maison',
  'In your pocket': 'En poche',
  'None yet; pick two on the phone': 'Aucun ; choisissez-en deux sur le téléphone',
  'None yet': 'Aucun',
  'Not yet': 'Pas encore',
  'scene {n} of {total}': 'scène {n} sur {total}',
  // the prologue
  'You were born in': 'Vous êtes né(e) à',
  'The year does not matter here. The place does.': 'L\'année n\'a pas d\'importance ici. Le lieu, oui.',
  'Ntarikon, in a single room by the stream. Your mother sold garri at Food Market.': 'Ntarikon, dans une chambre près du ruisseau. Votre mère vendait du garri au Food Market.',
  "Nkwen, in your father's compound behind the Nkwen market. Chickens, a maize farm, cousins everywhere.": 'Nkwen, dans la concession de votre père derrière le marché. Des poules, un champ de maïs, des cousins partout.',
  'Up Station, in a flat with a view down over the whole city. Your father was a civil servant.': 'Up Station, dans un appartement avec vue sur toute la ville. Votre père était fonctionnaire.',
  "A village at Bafut. Your mother's farm fed you; the Fon's palace was a walk away.": 'Un village à Bafut. Le champ de votre mère vous nourrissait ; le palais du Fon était à deux pas.',
  'Yaoundé, to parents who later left for Germany and sent you back to your grandmother in Bamenda.': 'Yaoundé, de parents partis ensuite en Allemagne, qui vous ont renvoyé(e) chez votre grand-mère à Bamenda.',
  'At six': 'À six ans',
  'Every child in Bamenda is raised by more than two people.': 'À Bamenda, chaque enfant est élevé par plus de deux personnes.',
  'You were sent to the village to your grandmother. Water from the stream, church every Sunday, stories at night.': 'On vous a envoyé(e) au village chez votre grand-mère. L\'eau du ruisseau, l\'église chaque dimanche, des contes le soir.',
  'You stayed home and ran the quarter with the other children. Football in the dust until the light went.': 'Vous êtes resté(e) au quartier avec les autres enfants. Du football dans la poussière jusqu\'à la nuit.',
  'Your father went to Douala to find work and came home at Christmas. You learned early how money moves.': 'Votre père est parti chercher du travail à Douala et rentrait à Noël. Vous avez vite compris comment l\'argent circule.',
  'You lived with your aunt who ran a hair salon on Commercial Avenue. You could braid before you could spell.': 'Vous viviez chez votre tante, coiffeuse sur Commercial Avenue. Vous saviez tresser avant de savoir épeler.',
  'Primary school': 'L\'école primaire',
  'Government School, "free", with PTA fees of 15,000 FCFA a year that were not always there.': 'L\'école publique, « gratuite », avec des frais d\'APEE de 15 000 FCFA par an qui n\'étaient pas toujours là.',
  'The fees were paid every September, somehow. You never missed a term.': 'Les frais étaient payés chaque septembre, on ne sait comment. Vous n\'avez jamais raté un trimestre.',
  'Some years the fees came late and you stayed home a term. You caught up; you also learned to sell.': 'Certaines années, les frais tardaient et vous restiez un trimestre à la maison. Vous avez rattrapé ; vous avez aussi appris à vendre.',
  'You sold puff-puff from a tray after school to pay your own fees. Everybody in the quarter knew you.': 'Vous vendiez des beignets sur un plateau après l\'école pour payer vos frais. Tout le quartier vous connaissait.',
  'The crisis closed the school for two years. You learned at home from an uncle and from the radio.': 'La crise a fermé l\'école deux ans. Vous avez appris à la maison, avec un oncle et la radio.',
  'The GCE year': 'L\'année du GCE',
  'Form Five. Everybody tells you this exam decides your life. It decides something.': 'La Form Five. Tout le monde dit que cet examen décide de votre vie. Il décide de quelque chose.',
  'You read under the kerosene lamp until the neighbours complained. Eight papers passed.': 'Vous avez lu sous la lampe à pétrole jusqu\'à ce que les voisins se plaignent. Huit matières réussies.',
  'You played for the quarter team and passed four papers. Nobody in Nkwen forgets the final.': 'Vous avez joué pour l\'équipe du quartier et réussi quatre matières. Personne à Nkwen n\'oublie la finale.',
  'You fixed phones at the motor park on weekends and passed five. The park chairman knows your name.': 'Vous répariez des téléphones à la gare routière le week-end et avez réussi cinq matières. Le chairman connaît votre nom.',
  'You led the church choir and passed six. The whole quarter heard your voice.': 'Vous dirigiez la chorale et avez réussi six matières. Tout le quartier entendait votre voix.',
  'After Form Five': 'Après la Form Five',
  'The family sat down. Fees, or a trade, or the road.': 'La famille s\'est réunie. Les frais, un métier, ou la route.',
  'The University of Bamenda at Bambili: 50,000 a year, a hostel bed, two-minute noodles.': 'L\'Université de Bamenda à Bambili : 50 000 par an, un lit en cité, des nouilles instantanées.',
  'Apprentice to a mechanic at Mile 4. Three years of grease and no pay, then your own tools.': 'Apprenti mécanicien à Mile 4. Trois ans de cambouis sans salaire, puis vos propres outils.',
  'Apprentice at a salon on Commercial Avenue. You can do wigs, braids and gossip.': 'Apprentie dans un salon de Commercial Avenue. Perruques, tresses et commérages.',
  'The motor park. Loading, calling passengers, counting coins. Nothing in Bamenda moves without you.': 'La gare routière. Charger, appeler les passagers, compter les pièces. Rien ne bouge à Bamenda sans vous.',
  "Your mother's kitchen became a restaurant and you were the cook. Achu on Tuesdays, pepper soup at night.": 'La cuisine de votre mère est devenue un restaurant et vous étiez aux fourneaux. Achu le mardi, pepper soup le soir.',
  'The year you turned twenty': 'L\'année de vos vingt ans',
  'Something happens to every family.': 'Il arrive quelque chose à chaque famille.',
  "Your father died. The death celebration took the family's savings and a loan; the compound went to his successor, your elder brother.": 'Votre père est mort. Les funérailles ont pris les économies de la famille et un prêt ; la concession est allée à son successeur, votre grand frère.',
  'Your mother fell ill and you carried the hospital bills for a year. She is better now.': 'Votre mère est tombée malade et vous avez porté les frais d\'hôpital pendant un an. Elle va mieux.',
  "Your mother's njangi came through and she put the pot in your hand: start something.": 'La tontine de votre mère est tombée et elle vous a mis la cagnotte dans la main : lancez quelque chose.',
  'Nothing. A quiet year, rain on the zinc, school fees paid. You left for town with a bag and a bucket.': 'Rien. Une année calme, la pluie sur la tôle, les frais payés. Vous êtes parti(e) en ville avec un sac et un seau.',
  // the hud
  Hunger: 'Faim',
  Energy: 'Énergie',
  Fun: 'Loisir',
  Social: 'Social',
  Hygiene: 'Hygiène',
  Bladder: 'Vessie',
  'You dey tire: chop or sleep': 'Vous êtes épuisé(e) : mangez ou dormez',
  'All controls': 'Toutes les commandes',
  Controls: 'Commandes',
  Close: 'Fermer',
  Dismiss: 'Fermer',
  'above sea level': 'd\'altitude',
  // actions in the dock and the pad
  'Greet the {who}': 'Saluer le/la {who}',
  Greet: 'Saluer',
  'Work: {place}': 'Travail : {place}',
  'Drive {what}': 'Conduire : {what}',
  'Find passenger': 'Chercher un client',
  'Give up ride': 'Abandonner la course',
  'On foot': 'À pied',
  'Stop building': 'Arrêter de construire',
  'Coach to {to}': 'Car pour {to}',
  'Chop {food} · {price}': 'Manger {food} · {price}',
  'At home': 'À la maison',
  'Land here': 'Atterrir ici',
  walk: 'marcher',
  run: 'courir',
  build: 'construire',
  town: 'la ville',
  news: 'infos',
  map: 'carte',
  mission: 'mission',
  'my places': 'mes lieux',
  chat: 'chat',
  drone: 'drone',
  phone: 'téléphone',
  fly: 'voler',
  'down, up': 'descendre, monter',
  fast: 'vite',
  'land here': 'atterrir ici',
  'back on foot': 'à pied',
  place: 'poser',
  remove: 'retirer',
  turn: 'tourner',
  colour: 'couleur',
  piece: 'pièce',
  'stop building': 'arrêter de construire',
  'give up the ride': 'abandonner la course',
  'find a passenger': 'chercher un client',
  'go, brake': 'avancer, freiner',
  steer: 'tourner',
  handbrake: 'frein à main',
  horn: 'klaxon',
  'get out': 'descendre',
  Jump: 'Sauter',
  Phone: 'Téléphone',
  Map: 'Carte',
  Chat: 'Chat',
  Move: 'Se déplacer',
  // the phone
  Me: 'Moi',
  Jobs: 'Emplois',
  Do: 'Faire',
  Market: 'Marché',
  Money: 'Argent',
  Family: 'Famille',
  Council: 'Mairie',
  Settings: 'Réglages',
  Music: 'Musique',
  Notifications: 'Notifications',
  Apps: 'Applis',
  'Nothing new. Greet people and the news of them comes here.': 'Rien de nouveau. Saluez les gens et leurs nouvelles arriveront ici.',
  'Pick your two traits and a dream in Me.': 'Choisissez vos deux traits et un rêve dans Moi.',
  'Say who you are in Family, once.': 'Dites qui vous êtes dans Famille, une seule fois.',
  'No job yet. Apply in Jobs, then work a shift a day.': 'Pas encore d\'emploi. Postulez dans Emplois, puis faites un service par jour.',
  '{need} is low. See Do.': '{need} est au plus bas. Voyez Faire.',
  'Back to the apps': 'Retour aux applis',
  'Close the phone': 'Fermer le téléphone',
  'The phone needs the server. It is not connected.': 'Le téléphone a besoin du serveur. Il n\'est pas connecté.',
  Needs: 'Besoins',
  'Choose two traits, once': 'Choisissez deux traits, une seule fois',
  'They shape how fast you learn and what wears you down.': 'Ils décident de la vitesse à laquelle vous apprenez et de ce qui vous use.',
  'Lifetime dream': 'Rêve d\'une vie',
  'Keep these': 'Garder',
  'Who you are': 'Qui vous êtes',
  'People you know: {n}': 'Gens que vous connaissez : {n}',
  'Greet people (E) and they remember you; you hear when life happens to them.': 'Saluez les gens (E) et ils se souviennent de vous ; vous apprenez ce qui leur arrive.',
  'You are at home in {place}.': 'Vous êtes chez vous à {place}.',
  'Home is in {place}. Things at home need you there.': 'Votre maison est à {place}. Ce qui se fait à la maison vous y attend.',
  'At a {place}': 'Dans un(e) {place}',
  'motor park': 'gare routière',
  bar: 'bar',
  market: 'marché',
  church: 'église',
  stadium: 'stade',
  pitch: 'terrain',
  Free: 'Gratuit',
  'Go there first': 'Allez-y d\'abord',
  'Ready in {n} min': 'Prêt dans {n} min',
  'a week, taken every Saturday': 'par semaine, prélevé chaque samedi',
  'Your things': 'Vos affaires',
  'Nothing yet. The Market sells things for the home.': 'Rien encore. Le Marché vend des choses pour la maison.',
  'Taxi home to {place}': 'Taxi jusqu\'à {place}',
  'The fare of the distance.': 'Le prix de la distance.',
  'Move house': 'Déménager',
  'Three weeks of the new rent up front.': 'Trois semaines du nouveau loyer d\'avance.',
  unfurnished: 'non meublé',
  Yours: 'À vous',
  Move: 'Déménager',
  'Move to a {home} in {where}?': 'Déménager dans un(e) {home} à {where} ?',
  'Three weeks of rent up front; your things come with you.': 'Trois semaines de loyer d\'avance ; vos affaires vous suivent.',
  'a shift': 'par service',
  '{n} shift': '{n} service',
  '{n} shifts': '{n} services',
  'performance {n}%': 'rendement {n} %',
  'Next level needs {skill} {need} (yours: {have}).': 'Le niveau suivant demande {skill} {need} (vous : {have}).',
  'Towards the next level': 'Vers le niveau suivant',
  'Go there in the shift hours and press E. One shift a day; late costs performance.': 'Allez-y aux heures de service et appuyez sur E. Un service par jour ; le retard coûte du rendement.',
  'Leave this job': 'Quitter cet emploi',
  'Leave {job}?': 'Quitter {job} ?',
  'You can apply again later; the level is lost.': 'Vous pourrez repostuler ; le niveau est perdu.',
  Leave: 'Quitter',
  'Other work in town': 'Autres emplois en ville',
  'Work in town': 'Emplois en ville',
  'Apply, then go there in the shift hours and press E. The nearest workplace of the kind to your home.': 'Postulez, puis allez-y aux heures de service et appuyez sur E. Le lieu de travail le plus proche de chez vous.',
  Apply: 'Postuler',
  Vehicles: 'Véhicules',
  'Yours waits outside your home each morning.': 'Le vôtre vous attend devant chez vous chaque matin.',
  Buy: 'Acheter',
  'Buy a {thing}?': 'Acheter {thing} ?',
  'Buy {thing}?': 'Acheter {thing} ?',
  Businesses: 'Commerces',
  'They pay every midnight without a shift; some days go badly.': 'Ils rapportent chaque minuit sans service ; certains jours vont mal.',
  'a day': 'par jour',
  weekends: 'week-ends',
  'earned {n}': 'rapporté {n}',
  Land: 'Terrains',
  'Grows in value every week; the quarter head takes a levy when you buy.': 'Prend de la valeur chaque semaine ; le chef de quartier prélève une taxe à l\'achat.',
  'Worth {n} now': 'Vaut {n} aujourd\'hui',
  Sell: 'Vendre',
  'Sell {thing}?': 'Vendre {thing} ?',
  'The buyer pays {n}.': 'L\'acheteur paie {n}.',
  'Grows {n}% a week': 'Prend {n} % par semaine',
  "With the quarter head's levy.": 'Avec la taxe du chef de quartier.',
  'For the home': 'Pour la maison',
  'This week': 'Cette semaine',
  'Rent on Saturday': 'Loyer samedi',
  'From your people': 'De votre famille',
  'Every Saturday': 'Chaque samedi',
  Njangi: 'Tontine',
  'The pot of 20,000 comes round in turn': 'La cagnotte de 20 000 revient à tour de rôle',
  Owed: 'Dû',
  'Paid from the next earnings': 'Prélevé sur les prochains gains',
  'Loan left': 'Reste du prêt',
  '{n} every Saturday': '{n} chaque samedi',
  'Borrow {n}': 'Emprunter {n}',
  'Repay {weekly} every Saturday for {weeks} weeks ({total} in all)': 'Rembourser {weekly} chaque samedi pendant {weeks} semaines ({total} en tout)',
  Take: 'Prendre',
  'Take {n}?': 'Prendre {n} ?',
  '{weekly} leaves every Saturday for {weeks} weeks. Miss it and your njangi seat goes.': '{weekly} partent chaque samedi pendant {weeks} semaines. Un retard et votre place à la tontine saute.',
  '{n} to repay': '{n} à rembourser',
  'Take the loan': 'Prendre le prêt',
  'Send money': 'Envoyer de l\'argent',
  '{fee}% fee, at most {cap} FCFA; {daily} a day.': '{fee} % de frais, au plus {cap} FCFA ; {daily} par jour.',
  'Player name': 'Nom du joueur',
  Amount: 'Montant',
  'Amount in FCFA': 'Montant en FCFA',
  To: 'À',
  Send: 'Envoyer',
  'A name and at least 100 FCFA.': 'Un nom et au moins 100 FCFA.',
  'Send {n} to {who}?': 'Envoyer {n} à {who} ?',
  'The fee is {n}.': 'Les frais sont de {n}.',
  'Asking the family…': 'On demande à la famille…',
  'Who are you?': 'Qui êtes-vous ?',
  'Said once. It decides whom you can marry and who inherits.': 'Dit une seule fois. Cela décide qui vous pouvez épouser et qui hérite.',
  'A man': 'Un homme',
  'A woman': 'Une femme',
  'Lived here {n} real day': 'Ici depuis {n} vrai jour',
  'Lived here {n} real days': 'Ici depuis {n} vrais jours',
  'You do not age; your children do, a year a day, and the town with them.': 'Vous ne vieillissez pas ; vos enfants si, un an par jour, et la ville avec eux.',
  Mother: 'Mère',
  Father: 'Père',
  Unknown: 'Inconnu',
  late: 'décédé(e)',
  'Brothers and sisters': 'Frères et sœurs',
  Wife: 'Épouse',
  Husband: 'Mari',
  None: 'Aucun',
  Separate: 'Se séparer',
  'Separate from {who}?': 'Se séparer de {who} ?',
  'She goes back to her people; the children mostly stay.': 'Elle retourne chez les siens ; les enfants restent pour la plupart.',
  'Second wife': 'Deuxième épouse',
  Heir: 'Héritier',
  'Not named': 'Pas désigné',
  'School fees': 'Frais de scolarité',
  'Your people': 'Les vôtres',
  'Children ({n})': 'Enfants ({n})',
  'Children come in their own time.': 'Les enfants viennent à leur heure.',
  'Marry first; or take in a kin child the town sends your way.': 'Mariez-vous d\'abord ; ou recueillez un enfant de la famille que la ville vous envoie.',
  'taken in': 'recueilli(e)',
  died: 'décédé(e)',
  'Name heir': 'Désigner héritier',
  'Hand over': 'Passer la main',
  'Go on as {heir}: the house and the name pass whole, the money less {cost} for the celebration, skills capped at level 3, the job given up.': 'Continuer en tant que {heir} : la maison et le nom passent entiers, l\'argent moins {cost} pour les funérailles, les compétences plafonnées au niveau 3, l\'emploi abandonné.',
  'Hand over to {heir}': 'Passer la main à {heir}',
  'Wait: {heir} is {age}': 'Attendez : {heir} a {age} ans',
  'Wait: live a real week first': 'Attendez : vivez d\'abord une vraie semaine',
  'Hand over to {heir}?': 'Passer la main à {heir} ?',
  'Your character becomes a townsperson and you go on as the heir.': 'Votre personnage devient un habitant et vous continuez en tant qu\'héritier.',
  'A second wife': 'Une deuxième épouse',
  Marry: 'Se marier',
  '{price}: the bride price list and the wedding. Only people you have greeted.': '{price} : la dot et le mariage. Seulement des gens que vous avez salués.',
  'Nobody yet: greet single people your age (E) and come back.': 'Personne encore : saluez des célibataires de votre âge (E) et revenez.',
  'met at {where}': 'rencontré(e) à {where}',
  Propose: 'Demander en mariage',
  'Propose to {who}?': 'Demander {who} en mariage ?',
  'The bride price list and the wedding, paid to her people.': 'La dot et le mariage, payés à sa famille.',
  'Asking the council…': 'On demande à la mairie…',
  Mayor: 'Maire',
  'No mayor yet': 'Pas encore de maire',
  'The first election is running.': 'La première élection est en cours.',
  'Until {date}.': 'Jusqu\'au {date}.',
  'Election closes {date}': 'L\'élection se termine le {date}',
  'Votes are cast at {place}; one each.': 'On vote à {place} ; une voix chacun.',
  'the council': 'la mairie',
  '{n} vote': '{n} voix',
  '{n} votes': '{n} voix',
  Vote: 'Voter',
  'You have voted': 'Vous avez voté',
  '(you)': '(vous)',
  'Stand for mayor': 'Se présenter comme maire',
  'Pick the policy you would hold for a term.': 'Choisissez la politique que vous tiendriez pendant un mandat.',
  Stand: 'Se présenter',
  'Stand on "{policy}"?': 'Se présenter avec « {policy} » ?',
  'Your name goes on the ballot until the election closes.': 'Votre nom figure sur le bulletin jusqu\'à la fin de l\'élection.',
  'Achievements ({n} of {total})': 'Succès ({n} sur {total})',
  'Day and night': 'Jour et nuit',
  'Real Bamenda time': 'L\'heure réelle de Bamenda',
  'A whole day every two hours': 'Une journée entière toutes les deux heures',
  Faster: 'Plus vite',
  'Real time': 'Temps réel',
  Sound: 'Son',
  On: 'Activé',
  Off: 'Coupé',
  'Turn on': 'Activer',
  'Turn off': 'Couper',
  Quality: 'Qualité',
  'changes on reload': 'change au rechargement',
  Change: 'Changer',
  'Name and look': 'Nom et allure',
  'Back to the first screen': 'Retour au premier écran',
  'English, French or Pidgin': 'Anglais, français ou pidgin',
  About: 'À propos',
  'Abakwa Mythlands. Map data © OpenStreetMap contributors. Everything in the town is fiction.': 'Abakwa Mythlands. Données cartographiques © les contributeurs d\'OpenStreetMap. Tout dans la ville est fiction.',
  // the side panels
  'In debt': 'Endetté',
  'Getting by': 'S\'en sort',
  Comfortable: 'À l\'aise',
  'Well off': 'Aisé',
  '{role}, {age} years old': '{role}, {age} ans',
  '{role}, died aged {age}': '{role}, décédé(e) à {age} ans',
  'Lives in': 'Habite à',
  Household: 'Foyer',
  'Lives alone': 'Vit seul(e)',
  '{n} people': '{n} personnes',
  Standing: 'Situation',
  'Works at': 'Travaille à',
  'Your neighbour in {where}.': 'Votre voisin(e) à {where}.',
  'Your family.': 'Votre famille.',
  'You greeted them {n} time, last at {where} on {date}.': 'Vous l\'avez salué(e) {n} fois, la dernière à {where} le {date}.',
  'You greeted them {n} times, last at {where} on {date}.': 'Vous l\'avez salué(e) {n} fois, la dernière à {where} le {date}.',
  Divorced: 'Divorcé(e)',
  Widowed: 'Veuf/veuve',
  'Raised by': 'Élevé(e) par',
  'kin, after losing the parents': 'la famille, après la perte des parents',
  Nature: 'Nature',
  Health: 'Santé',
  Mind: 'Esprit',
  Charm: 'Charme',
  'Has not been well in the mind lately; the family carries it.': 'Ne va pas bien dans sa tête ces temps-ci ; la famille le porte.',
  'In need of care; the family looks after them.': 'A besoin de soins ; la famille s\'en occupe.',
  'Known to the gendarmes.': 'Connu(e) des gendarmes.',
  People: 'Habitants',
  Homes: 'Maisons',
  '{n} empty': '{n} vides',
  'Young families housed': 'Jeunes familles logées',
  'Houses families built': 'Maisons construites par des familles',
  Fon: 'Fon',
  'Land and animals': 'Terres et animaux',
  'Food in the market': 'Nourriture au marché',
  dear: 'chère',
  cheap: 'bon marché',
  normal: 'normale',
  Grass: 'Herbe',
  Goats: 'Chèvres',
  Fowls: 'Volailles',
  Cattle: 'Bétail',
  'Bush animals': 'Gibier',
  'Hawks, snakes, civets': 'Éperviers, serpents, civettes',
  'The whole region, year {n}': 'Toute la région, année {n}',
  'Births so far': 'Naissances',
  'Deaths so far': 'Décès',
  'Left for the cities': 'Partis en ville',
  'Town news': 'Nouvelles de la ville',
  'Nothing of note has happened yet.': 'Rien de notable pour l\'instant.',
  'Year {n}': 'Année {n}',
  News: 'Infos',
  'Real headlines from Cameroonian news sites': 'Vrais titres des sites d\'information camerounais',
  'Notices from this server': 'Avis de ce serveur',
  Headlines: 'Titres',
  'No headlines could be fetched just now. They are checked every half hour.': 'Aucun titre n\'a pu être récupéré pour l\'instant. Ils sont relevés toutes les demi-heures.',
  'My places': 'Mes lieux',
  "Only you see these, unless you give someone a place's code": 'Vous seul(e) les voyez, sauf si vous donnez le code d\'un lieu',
  'Name the spot you are standing on': 'Nommez l\'endroit où vous êtes',
  'Name for this place': 'Nom de ce lieu',
  Save: 'Enregistrer',
  'from {who}': 'de {who}',
  'code to share: {code}': 'code à partager : {code}',
  Way: 'Itinéraire',
  Remove: 'Retirer',
  'Nothing saved yet. Stand at your house, name it above and press Save.': 'Rien d\'enregistré. Mettez-vous devant chez vous, nommez l\'endroit ci-dessus et appuyez sur Enregistrer.',
  "Friends' places": 'Lieux des amis',
  "A friend's code": 'Le code d\'un ami',
  "Code of a friend's place": 'Code du lieu d\'un ami',
  Add: 'Ajouter',
  'Chat message': 'Message du chat',
  'Say something to everyone': 'Dites quelque chose à tout le monde',
  // the notices
  'Mission hidden. Press M to show it again.': 'Mission masquée. Appuyez sur M pour la revoir.',
  'Sound on': 'Son activé',
  'Sound off': 'Son coupé',
  'Build mode off': 'Mode construction désactivé',
  'You slept well.': 'Vous avez bien dormi.',
  'Done.': 'Fait.',
  'Done: {title}. You earned {n} FCFA.': 'Terminé : {title}. Vous avez gagné {n} FCFA.',
  'Mission passed': 'Mission accomplie',
  'Lost the server. The town is quiet until it returns.': 'Serveur perdu. La ville est silencieuse jusqu\'à son retour.',
  'No light in {place}: a power cut': 'Pas de lumière à {place} : coupure de courant',
  'The light is back in {place}': 'La lumière est revenue à {place}',
  'You gave up the ride': 'Vous avez abandonné la course',
  'Fuel is short today: there are queues at the stations': 'Le carburant manque aujourd\'hui : files d\'attente aux stations',
  'Fuel has come: the queues at the stations are gone': 'Le carburant est arrivé : plus de files aux stations',
  'You show your ID card and are waved on': 'Vous montrez votre carte d\'identité et on vous fait signe de passer',
  'A control post: slow down and stop': 'Un poste de contrôle : ralentissez et arrêtez-vous',
  'Saturday: {parts}. You have {money} FCFA.': 'Samedi : {parts}. Il vous reste {money} FCFA.',
  'landlord took {n}': 'le bailleur a pris {n}',
  'you could not pay the rent, you owe {n}': 'vous n\'avez pas pu payer le loyer, vous devez {n}',
  'your people sent {n}': 'les vôtres ont envoyé {n}',
  'njangi took {n}': 'la tontine a pris {n}',
  'na your turn: the njangi pot of {n} is yours': 'c\'est votre tour : la cagnotte de {n} est à vous',
  'the microfinance took {n}': 'la microfinance a pris {n}',
  'you defaulted on the loan: your njangi seat is gone and the rest is debt': 'vous n\'avez pas remboursé le prêt : votre place à la tontine saute et le reste devient dette',
  'You chop {food}.': 'Vous avez mangé {food}.',
  'You married {who}. The bride price and the wedding came to {n} FCFA.': 'Vous avez épousé {who}. La dot et le mariage ont coûté {n} FCFA.',
  '{who} has gone back to her people.': '{who} est retournée chez les siens.',
  'You go on as {who}. The celebration cost {n} FCFA; the house and the name are yours.': 'Vous continuez en tant que {who}. Les funérailles ont coûté {n} FCFA ; la maison et le nom sont à vous.',
  'The taxi dropped you at {place}. Fare {n} FCFA.': 'Le taxi vous a déposé(e) à {place}. Course : {n} FCFA.',
  'Achievement: {name}. {n} FCFA.': 'Succès : {name}. {n} FCFA.',
  'News: {text}': 'Nouvelle : {text}',
  'You voted for {who}.': 'Vous avez voté pour {who}.',
  // the big map
  Town: 'Ville',
  Village: 'Village',
  Quarter: 'Quartier',
  School: 'École',
  College: 'Collège',
  University: 'Université',
  Hospital: 'Hôpital',
  Clinic: 'Clinique',
  'Place of worship': 'Lieu de culte',
  Bank: 'Banque',
  'Fuel station': 'Station-service',
  'Motor park': 'Gare routière',
  Hotel: 'Hôtel',
  Airport: 'Aéroport',
  Stadium: 'Stade',
  'Place to see': 'À voir',
  Police: 'Police',
  Food: 'Restauration',
  'Find a place': 'Trouver un lieu',
  'Places found': 'Lieux trouvés',
  'Close the map': 'Fermer la carte',
  'Town hall': 'Mairie',
  Pharmacy: 'Pharmacie',
  Shop: 'Boutique',
  Legend: 'Légende',
  'Go here': 'Aller ici',
  'Clear the route': 'Effacer l\'itinéraire',
  '{n} m': '{n} m',
  '{n} km': '{n} km',
  'Route: {dist} to {place}': 'Itinéraire : {dist} jusqu\'à {place}',
  'You have arrived at {place}': 'Vous êtes arrivé(e) à {place}',
  // content: needs, skills, traits, homes, items, actions, careers, dreams, achievements
  Cooking: 'Cuisine',
  Charisma: 'Charisme',
  Fitness: 'Forme',
  Coding: 'Informatique',
  Dance: 'Danse',
  Comedy: 'Comédie',
  Photography: 'Photographie',
  Hustle: 'Débrouille',
  Hustler: 'Débrouillard',
  'Hustle grows half again as fast.': 'La débrouille progresse une fois et demie plus vite.',
  Foodie: 'Gourmand',
  'Cooking grows 1.6x; food fills you more.': 'La cuisine progresse 1,6 fois plus vite ; la nourriture nourrit mieux.',
  'Tech Bro / Sis': 'Geek',
  'Coding grows 1.6x.': 'L\'informatique progresse 1,6 fois plus vite.',
  Musical: 'Musicien',
  'Music grows 1.6x.': 'La musique progresse 1,6 fois plus vite.',
  'Smooth Talker': 'Beau parleur',
  'Charisma grows half again as fast.': 'Le charisme progresse une fois et demie plus vite.',
  'Gym Rat': 'Sportif',
  'Fitness grows 1.6x.': 'La forme progresse 1,6 fois plus vite.',
  'Owambe Spirit': 'Fêtard',
  'Fun drains slower, social fills faster.': 'Le loisir baisse moins vite, le social remonte plus vite.',
  'Lazy Bone': 'Paresseux',
  'Energy drains slower; work performance -10%.': 'L\'énergie baisse moins vite ; rendement au travail -10 %.',
  'Clean Pikin': 'Propre sur soi',
  'Hygiene drains slower.': 'L\'hygiène baisse moins vite.',
  'Night Crawler': 'Oiseau de nuit',
  'Night shifts pay 10% more.': 'Les services de nuit paient 10 % de plus.',
  'Commercial Avenue Mogul': 'Magnat de Commercial Avenue',
  'Up Station Landlord': 'Propriétaire à Up Station',
  "Bamenda's Voice": 'La voix de Bamenda',
  "Fon's Notable": 'Notable du Fon',
  'Motor-Park Chairman': 'Chairman de la gare routière',
  'Bushfaller Returnee': 'Bushfaller de retour',
  'Hostel bed': 'Lit en cité',
  'Single room': 'Chambre',
  'Self-contain': 'Studio',
  'Mini-flat': 'Petit appartement',
  Flat: 'Appartement',
  Duplex: 'Duplex',
  'Compound with a view': 'Concession avec vue',
  'Bucket and bowl': 'Seau et cuvette',
  'Water drum': 'Fût d\'eau',
  'Foam mattress': 'Matelas mousse',
  Blanket: 'Couverture',
  'Kerosene stove': 'Réchaud à pétrole',
  'Gas cooker': 'Cuisinière à gaz',
  'Cooler box': 'Glacière',
  Fridge: 'Réfrigérateur',
  'Standing fan': 'Ventilateur',
  Radio: 'Radio',
  Television: 'Télévision',
  Decoder: 'Décodeur',
  'Games console': 'Console de jeux',
  'Split air conditioner': 'Climatiseur',
  'Rechargeable lamp': 'Lampe rechargeable',
  '"I better pass my neighbour" generator': 'Groupe électrogène « I better pass my neighbour »',
  'Solar panel and inverter': 'Panneau solaire et onduleur',
  'A local dog': 'Un chien du quartier',
  Sleep: 'Dormir',
  Nap: 'Sieste',
  Bathe: 'Se laver',
  Toilet: 'Toilettes',
  'Cook a plate': 'Cuisiner un plat',
  'Relax at home': 'Se détendre à la maison',
  'A beer': 'Une bière',
  'Toilet (50 FCFA)': 'Toilettes (50 FCFA)',
  'Motor-park toilet': 'Toilettes de la gare',
  'Watch the match': 'Regarder le match',
  'Kick a ball': 'Taper le ballon',
  'Attend the service': 'Assister au culte',
  'Gist with the traders': 'Bavarder avec les vendeurs',
  'Watch a film': 'Regarder un film',
  'Read and practise': 'Lire et s\'exercer',
  Banking: 'Banque',
  Nursing: 'Soins infirmiers',
  Teaching: 'Enseignement',
  Lecturing: 'Enseignement supérieur',
  'Council clerk': 'Agent communal',
  'Radio presenter': 'Animateur radio',
  'Market trading': 'Commerce au marché',
  Shopkeeping: 'Boutique',
  Hairdressing: 'Coiffure',
  'Hotel work': 'Hôtellerie',
  DJ: 'DJ',
  Football: 'Football',
  Mechanic: 'Mécanique',
  Tech: 'Informatique',
  'Content creator': 'Créateur de contenu',
  'Coach loader': 'Chargeur de car',
  'Church work': 'Église',
  'Call box and recharge kiosk': 'Call-box et recharges',
  'Provision store': 'Alimentation',
  'Barbing salon': 'Salon de coiffure',
  Buka: 'Tournedos',
  'Car wash': 'Lavage auto',
  'Event hall': 'Salle de fêtes',
  '5% of a hotel': '5 % d\'un hôtel',
  'Plot in Ntarikon': 'Parcelle à Ntarikon',
  'Plot in Nkwen': 'Parcelle à Nkwen',
  'Plot at Mile 4': 'Parcelle à Mile 4',
  'Plot on Foncha Street': 'Parcelle à Foncha Street',
  'Plot at Up Station': 'Parcelle à Up Station',
  'Okada (used)': 'Moto-taxi (occasion)',
  'Toyota Corolla (used)': 'Toyota Corolla (occasion)',
  'Corolla taxi, licensed': 'Taxi Corolla, avec licence',
  'Pickup (used)': 'Pick-up (occasion)',
  'Hiace minibus': 'Minibus Hiace',
  'Mutuelle microfinance': 'Mutuelle de microfinance',
  'First pay': 'Première paie',
  'Steady hand': 'Main sûre',
  'First passenger': 'Premier client',
  'Road warrior': 'Roi de la route',
  'Everybody knows you': 'Tout le monde vous connaît',
  'Small business': 'Petit commerce',
  Millionaire: 'Millionnaire',
  'Big house': 'Grande maison',
  'puff-puff': 'des beignets',
  bread: 'du pain',
  'roasted plantain': 'du plantain braisé',
  'a plate of fufu and njama njama': 'un plat de fufu et njama njama',
  'km/h': 'km/h',
  'All {n} missions done': 'Les {n} missions sont faites',
  'The town is yours to build': 'La ville est à vous',
  'Keep working, keep building, and watch the families you housed grow.': 'Continuez à travailler, à construire, et regardez grandir les familles que vous avez logées.',
  'Mission {n} of {total} · {reward} FCFA': 'Mission {n} sur {total} · {reward} FCFA',
  'Step {n} of {total}': 'Étape {n} sur {total}',
  level: 'niveau',
  wk: 'sem',
  'turn left in {n} m': 'à gauche dans {n} m',
  'turn right in {n} m': 'à droite dans {n} m',
  'you are there': 'vous y êtes',
  'No road leads there; follow the marker': 'Aucune route n\'y mène ; suivez le repère',
  'the place you marked': 'l\'endroit marqué',
  Place: 'Lieu',
  'Your route': 'Votre itinéraire',
  'Where you are going': 'Votre destination',
  'Drag to move · scroll or pinch to zoom · tap a place to go there': 'Glissez pour bouger · molette ou pincement pour zoomer · touchez un lieu pour y aller',
  'On the way to {place}': 'En route pour {place}',
  Next: 'Ensuite',
  'Paste a YouTube link': 'Collez un lien YouTube',
  'YouTube link': 'Lien YouTube',
  Play: 'Lire',
  'Search on YouTube': 'Chercher sur YouTube',
  'Play a song or a playlist': 'Lire un morceau ou une playlist',
  'Any video or playlist link. A video whose label has switched off embedding says so; pick another.': 'N\'importe quel lien de vidéo ou de playlist. Si le label a bloqué l\'intégration, la vidéo le dit ; choisissez-en une autre.',
  Stations: 'Stations',
  'The owner can list playlists in public/music.json; they appear here for everyone.': 'Le propriétaire peut lister des playlists dans public/music.json ; elles apparaissent ici pour tous.',
  Recent: 'Récents',
  Playlist: 'Playlist',
  Video: 'Vidéo',
  Stop: 'Arrêter',
  'Nothing playing. Paste a link below.': 'Rien en lecture. Collez un lien ci-dessous.',
  Playing: 'En lecture',
  'No signal': 'Pas de réseau',
  'Put the phone away': 'Ranger le téléphone',
};
